import { type EffectCallback, useEffect, useEffectEvent } from 'react';

export function useMountEffect(effect: EffectCallback) {
  const runEffect = useEffectEvent(effect);

  useEffect(() => {
    return runEffect();
  }, []);
}
